namespace GeniuzPOS.Product {
    export class CsPluColumns {
        static columnsKey = 'Product.CsPlu';
    }
}
